import { useState, useEffect } from "react";
import alanBtn from '@alan-ai/alan-sdk-web';
import "./style.css";
function App() {
  const [cart, setCart] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  useEffect(() => {
    alanBtn({
        key: 'a8ec9e2126b586c77eeff9c26f74b36e2e956eca572e1d8b807a3e2338fdd0dc/stage',
        onCommand: (commandData) => {
          if(commandData.command === "getMenu"){
            setMenuItems(commandData.data);
          }else if(commandData.command === "addToCart"){
            addtoCart(commandData.data);
          }
        }
    });
  }, []);
  const addtoCart = (menuItem) => {
    setCart(
      (oldcart) => {
        return [...oldcart,menuItem]
      }
    )
  }
  return (
    <div className="App">
       <p>Start saying! <mark>Show me the menu bar</mark> to display items..</p>
        <p>You can order items by price by saying <mark>Order by price</mark></p>
        <p>You can order items by name by saying <mark>Order by name</mark></p>
        <p>You can order items by category by saying <mark>Order by category</mark></p>
        <p>You can add items into cart by saying <mark>name</mark> of the item. For example, if you want to add "Chicken Biryani" say <mark>Add chicken biryani to the cart</mark></p>

        <h1 id="menuName">Menu</h1>
        {menuItems.map(
          (menuItem) => (
            <li  key={menuItem.name}><b id="food">{menuItem.name}</b> - <b id="price">Rs.{menuItem.price}</b> - <i>{menuItem.category}</i></li>))
        } 
        <h1>Cart</h1>
        {cart.map(
          (cartItem) => (<li key={cartItem.name}><b id="food">{cartItem.name}</b> - <b id="price">Rs.{cartItem.price}</b> - <i>{cartItem.category}</i></li>))
        }  
    </div>
  );
}

export default App;
